class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onOpeningTransitionEnd = this.onOpeningTransitionEnd.bind(this);

    // Five seconds gives customers time to recognize the product and choose an action.
    this.autoDismissDelay = 5000;
    this.autoDismissTimer = null;
    this.notification.addEventListener('mouseenter', () => this.cancelAutoDismiss());
    this.notification.addEventListener('mouseleave', () => this.scheduleAutoDismiss());
    // The notification itself is focused on open by the existing Shopify code.
    // Pause only when the customer deliberately focuses an interactive child.
    this.notification.addEventListener('focusin', (event) => {
      if (event.target !== this.notification) this.cancelAutoDismiss();
    });
    this.notification.addEventListener('focusout', (event) => {
      if (!this.notification.contains(event.relatedTarget)) this.scheduleAutoDismiss();
    });

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    const wasOpen = this.notification.classList.contains('active');
    // One listener per opening, even if two products are added close together.
    this.notification.removeEventListener('transitionend', this.onOpeningTransitionEnd);
    this.notification.classList.add('animate', 'active');
    if (!wasOpen) {
      this.notification.addEventListener('transitionend', this.onOpeningTransitionEnd);
    }

    document.body.addEventListener('click', this.onBodyClick);
    this.scheduleAutoDismiss();
  }

  onOpeningTransitionEnd(event) {
    // Ignore events bubbling from controls inside the notification.
    if (event.target !== this.notification || event.propertyName !== 'transform') return;
    this.notification.removeEventListener('transitionend', this.onOpeningTransitionEnd);
    if (!this.notification.classList.contains('active')) return;
    this.notification.focus();
    trapFocus(this.notification);
  }

  close() {
    this.cancelAutoDismiss();
    // Prevent a late transition from moving focus back into a closed dropdown.
    this.notification.removeEventListener('transitionend', this.onOpeningTransitionEnd);
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }


  cancelAutoDismiss() {
    window.clearTimeout(this.autoDismissTimer);
    this.autoDismissTimer = null;
  }

  scheduleAutoDismiss() {
    this.cancelAutoDismiss();

    if (!this.notification.classList.contains('active')) return;
    if (this.notification.matches(':hover')) return;
    const focused = document.activeElement;
    if (focused !== this.notification && this.notification.contains(focused)) return;

    this.autoDismissTimer = window.setTimeout(() => {
      this.autoDismissTimer = null;
      if (this.notification.classList.contains('active')) this.close();
    }, this.autoDismissDelay);
  }

  updateCartBubble(html) {
    if (!html) return;
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    const updated = new DOMParser().parseFromString(html, 'text/html')
      .querySelector('.cart-count-bubble');
    const current = cartIcon.querySelector('.cart-count-bubble');
    if (current) current.remove();
    if (updated) cartIcon.appendChild(updated);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!html) return;
      if (section.id === 'cart-icon-bubble') {
        this.updateCartBubble(html);
        return;
      }
      const target = document.getElementById(section.id);
      if (target) target.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }


  showReorderSummary(productCount, unitCount, sections) {
    const target = document.getElementById('cart-notification-product');
    if (!target) return;

    const products = Math.max(0, Math.trunc(Number(productCount) || 0));
    const units = Math.max(0, Math.trunc(Number(unitCount) || 0));
    const summary = document.createElement('div');
    summary.className = 'cwl-reorder-summary';

    const title = document.createElement('strong');
    title.className = 'cwl-reorder-summary__title';
    title.textContent = products + ' product' + (products === 1 ? '' : 's') + ' added';

    const details = document.createElement('span');
    details.className = 'cwl-reorder-summary__detail';
    details.textContent = units + ' total item' + (units === 1 ? '' : 's') + ' from your previous order';

    summary.appendChild(title);
    summary.appendChild(details);
    target.replaceChildren(summary);

    // The View Order label is static. Only the cart badge needs refreshing.
    this.updateCartBubble(sections && sections['cart-icon-bubble']);

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
